var exports = {
  "id": "x93eb46d8--a5643c--discount",
  "_R": "x93eb46d8--a5643c--original-price",
  "ip": "x93eb46d8--a5643c--discount-percent",
};

module.exports = exports;
